import React from 'react';
import mime from 'mime-types';
import MicRecorder from 'mic-recorder-to-mp3';
import ReactAudioPlayer from 'react-audio-player';
import { Modal, Icon, Button } from 'semantic-ui-react';

const Mp3Recorder = new MicRecorder({ bitRate: 128 });

class VoiceModal extends React.Component {

  // Initial State
  constructor(props) {
    super(props);
    window.AudioContext = window.AudioContext || window.webkitAudioContext;

    this.state = {
      isRecording: false,
      isPaused: false,
      blobURL: "",
      mp3file: null, 
      isBlocked: false
    };
 }

  // Records Voice
  startRecording = () => {
    if (this.state.isBlocked) {
      console.log("Please give permission for the microphone to record audio.");
    } else {
      Mp3Recorder.start()
        .then(() => {
          this.setState({ isRecording: true });
        })
        .catch(e => console.error(e));
    }
  };

  // Stops Recording Voice
  stopRecording = () => {
    this.setState({ isRecording: false });
    Mp3Recorder.stop()
      .getMp3()
      .then(async ([buffer, blob]) => {
        const mp3file = new File(buffer, 'me-at-thevoice.mp3', {
          type: blob.type,
          lastModified: Date.now()
        });
        const blobURL = URL.createObjectURL(blob)
        this.setState({ 
          blobURL: blobURL,
          mp3file: mp3file, 
          isRecording: false
        });
      })
      .catch(e => console.log(e));
  };

  // Checks Audio Permissions
  checkPermissionForAudio = () => {
    if (navigator.mediaDevices === undefined) {
      navigator.mediaDevices = {};
    }
    if (navigator.mediaDevices.getUserMedia === undefined) {
      navigator.mediaDevices.getUserMedia = function(constraints) {
        // First get ahold of the legacy getUserMedia, if present
        var getUserMedia =
          // navigator.getUserMedia ||
          navigator.webkitGetUserMedia || navigator.mozGetUserMedia;

        // Some browsers just don't implement it - return a rejected promise with an error
        // to keep a consistent interface
        if (!getUserMedia) {
          return Promise.reject(
            new Error("getUserMedia is not implemented in this browser")
          );
        }

        // Otherwise, wrap the call to the old navigator.getUserMedia with a Promise
        return new Promise(function(resolve, reject) {
          getUserMedia.call(navigator, constraints, resolve, reject);
        });
      };
    }
    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then(stream => {
        this.setState({ isBlocked: false });
      })
      .catch(err => {
        this.setState({ isBlocked: true });
        console.log("Please give permission for the microphone to record audio.");      
        console.log(err.name + ": " + err.message);
      });
  };

  componentDidMount() {
    this.checkPermissionForAudio();
  }

  // Sends Voice embedded file
  sendFile = () => {

    const { mp3file } = this.state;
    const { uploadVoice, closeVoiceModal } = this.props;

    if (mp3file !== null) {
        const metadata = { contentType: mime.lookup(mp3file.name) };
        uploadVoice(mp3file, metadata)
        closeVoiceModal();
        this.clearFile();
    }
  };

  clearFile = () => this.setState({ mp3file: null });

  render() {

    const { voiceModal, closeVoiceModal } = this.props;
    const { isRecording } = this.state;

    return (
      <Modal basic open={voiceModal} onClose={closeVoiceModal}>

      <Button 
        onClick={this.startRecording}
        className="mr-3 add-collec-btn"
        disabled={isRecording}
      >
        Record
      </Button>

        <Button
          onClick={this.stopRecording}
          className="mr-3 delete-btn"
          disabled={!isRecording}
        >
          Stop
        </Button>

        <ReactAudioPlayer
          src={this.state.blobURL || ""}
          controls
        />

        <Modal.Actions>
          <Button onClick={this.sendFile} color='green' inverted >
            <Icon name='checkmark'/> Send
          </Button>
          <Button color='red' inverted onClick={closeVoiceModal}>
            <Icon name='remove'/> Cancel
          </Button>
        </Modal.Actions>        
        </Modal>
    );
  }
}

export default VoiceModal;